export default __webpack_public_path__ + "static/404-1-8d3819615addc54550078f280da56c43.jpg";